import React from "react";
import { Tooltip } from "@mui/material";

const CustomTooltip = ({ title, placement, children }) => {
  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      classes={{
        tooltip: "hayley-bg-secondary hayley-rounded-none hayley-font-opensans hayley-text-sm hayley-text-white hayley-py-[6px] hayley-px-[10px]",
        arrow: "hayley-text-secondary",
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
